<template>
    <ul class="mainmenu">
        <li class="has-droupdown has-menu-child-item">
            <router-link to="/">
                {{$t('home')}}
            </router-link>
            <!-- <ul class="submenu">
                <li><router-link to="/business-consulting">Business Consulting</router-link></li>
                <li><router-link to="/business-consulting-2">Business Consulting 02</router-link></li>
                <li><router-link to="/corporate">Corporate</router-link></li>
                <li><router-link to="/business">Business</router-link></li>
                <li><router-link to="/digital-agency">Digital Agency</router-link></li>
                <li><router-link to="/finance">Finance</router-link></li>
                <li><router-link to="/company">Company</router-link></li>
                <li><router-link to="/marketing-agency">Marketing Agency</router-link></li>
                <li><router-link to="/travel-agency">Travel Agency</router-link></li>
                <li><router-link to="/consulting">Consulting</router-link></li>
                <li><router-link to="/seo-agency">SEO Agency</router-link></li>
                <li><router-link to="/personal-portfolio">Personal Portfolio</router-link></li>
                <li><router-link to="/event-conference">Event Conference</router-link></li>
                <li><router-link to="/creative-portfolio">Creative Portfolio</router-link></li>
                <li><router-link to="/freelancer">Freelancer</router-link></li>
                <li><router-link to="/international-consulting">International Consulting</router-link></li>
                <li><router-link to="/startup">Startup</router-link></li>
                <li><router-link to="/web-agency">Web Agency</router-link></li>
            </ul> -->
        </li>
        <!-- <li><a>{{$t('products')}}</a></li> -->
        <!-- <li class="with-megamenu has-menu-child-item">
            <a>
                {{$t('appService')}}
                <Icon name="plus" class="collapse-icon plus"/>
                <Icon name="minus" class="collapse-icon minus"/>
            </a>
            
            <div class="rn-megamenu">
                <div class="wrapper">
                    <div class="row row--0">
                        <div class="col-lg-3 single-mega-item">
                            <ul class="mega-menu-item">
                                <li><router-link to="/button">Button</router-link></li>
                                <li><router-link to="/service">Service</router-link></li>
                                <li><router-link to="/counter">Counter</router-link></li>
                                <li><router-link to="/progressbar">Progressbar</router-link></li>
                                <li><router-link to="/accordion">Accordion</router-link></li>
                                <li><router-link to="/social-share">Social Share</router-link></li>
                                <li><router-link to="/blog-grid">Blog Grid</router-link></li>
                            </ul>
                        </div>
                        <div class="col-lg-3 single-mega-item">
                            <ul class="mega-menu-item">
                                <li><router-link to="/team">Team</router-link></li>
                                <li><router-link to="/portfolio">Portfolio</router-link></li>
                                <li><router-link to="/testimonial">Testimonial</router-link></li>
                                <li><router-link to="/timeline">Timeline</router-link></li>
                                <li><router-link to="/tab">Tab</router-link></li>
                                <li><router-link to="/pricing">Pricing</router-link></li>
                                <li><router-link to="/spit-section">Split Section</router-link></li>
                            </ul>
                        </div>
                        <div class="col-lg-3 single-mega-item">
                            <ul class="mega-menu-item">
                                <li><router-link to="/call-to-action">Call To Action</router-link></li>
                                <li><router-link to="/video">Video</router-link></li>
                                <li><router-link to="/gallery">Gallery</router-link></li>
                                <li><router-link to="/contact">Contact</router-link></li>
                                <li><router-link to="/brand">Brand</router-link></li>
                                <li><router-link to="/portfolio">Portfolio</router-link></li>
                                <li><router-link to="/error">404</router-link></li>
                            </ul>
                        </div>
                        <div class="col-lg-3 single-mega-item">
                            <ul class="mega-menu-item">
                                <li>
                                    <router-link to="/advance-tab">
                                        Advance Tab <span class="rn-badge-card">Hot</span>
                                    </router-link>
                                </li>
                                <li>
                                    <router-link to="#">
                                        Brand Carousel <span class="rn-badge-card">Comming</span>
                                    </router-link>
                                </li>
                                <li>
                                    <router-link to="/advance-pricing">
                                        Advance Pricing <span class="rn-badge-card">Hot</span>
                                    </router-link>
                                </li>
                                <li>
                                    <router-link to="/portfolio-details/1">
                                        Portfolio Details
                                    </router-link>
                                </li>
                                <li>
                                    <router-link to="/blog-details/1">
                                        Blog Details
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </li> -->

        <li class="has-droupdown has-menu-child-item">
            <a style="cursor: pointer;">
                {{$t('appService')}}
                <Icon name="plus" class="collapse-icon plus"/>
                <Icon name="minus" class="collapse-icon minus"/>
            </a>
            <!-- <div class="submenu" style="min-width: 380px" v-if="isZh">
                <div class="row row--0">
                    <div class="col-lg-6 single-mega-item">
                        <ul class="mega-menu-item">
                             <li><router-link to="/fitshowApp">{{ $t('fitshowApp') }}</router-link></li>
                            <li><router-link to="/embeddedApp">{{ $t('embeddedApp') }}</router-link></li>
                            <li><router-link to="/oemApp">{{ $t('oemAPP') }}</router-link></li> 
                        </ul>
                    </div>
                     <div class="col-lg-6 single-mega-item">
                        <ul class="mega-menu-item">
                            <li><a target="_blank" href="https://gitee.com/fitshow/fswiki/tree/master/%E8%AE%A4%E8%AF%81%E8%AF%81%E4%B9%A6">{{ $t('authCert') }}</a></li>
                            <li><a target="_blank" href="https://gitee.com/fitshow/fswiki/tree/master/%E9%80%9A%E8%AE%AF%E5%8D%8F%E8%AE%AE">{{ $t('commProto') }}</a></li>
                            <li><a target="_blank" href="https://gitee.com/fitshow/fswiki/tree/master/%E4%BA%A7%E5%93%81%E8%A7%84%E6%A0%BC%E4%B9%A6">{{ $t('productCert') }}</a></li>
                        </ul>
                    </div>
                </div>
            </div> -->
            <ul class="submenu">
                <li><router-link to="/fitshowApp">{{ $t('fitshowApp') }}</router-link></li>
                <li><router-link to="/embeddedApp">{{ $t('embeddedApp') }}</router-link></li>
                <li><router-link to="/oemApp">{{ $t('oemAPP') }}</router-link></li>
            </ul>
        </li>


        <li class="has-droupdown has-menu-child-item" v-if="isZh">
            <a style="cursor: pointer;">
                {{$t('technicalData')}}
                <Icon name="plus" class="collapse-icon plus"/>
                <Icon name="minus" class="collapse-icon minus"/>
            </a>
            <ul class="submenu">
                <li><a target="_blank" href="https://gitee.com/fitshow/fswiki/tree/master/%E8%AE%A4%E8%AF%81%E8%AF%81%E4%B9%A6">{{ $t('authCert') }}</a></li>
                <li><a target="_blank" href="https://gitee.com/fitshow/fswiki/tree/master/%E9%80%9A%E8%AE%AF%E5%8D%8F%E8%AE%AE">{{ $t('commProto') }}</a></li>
                <li><a target="_blank" href="https://gitee.com/fitshow/fswiki/tree/master/%E4%BA%A7%E5%93%81%E8%A7%84%E6%A0%BC%E4%B9%A6">{{ $t('productCert') }}</a></li>
            </ul>
        </li>

         <!-- <li class="has-droupdown has-menu-child-item">
            <a>
                {{$t('download')}}
                <Icon name="plus" class="collapse-icon plus"/>
                <Icon name="minus" class="collapse-icon minus"/> 
            </a>
           <ul class="submenu">
                <li><router-link to="/portfolio">Portfolio Default</router-link></li>
                <li><router-link to="/portfolio-three-column">Portfolio Three Column</router-link></li>
                <li><router-link to="/portfolio-full-width">Portfolio Full Width</router-link></li>
                <li><router-link to="/portfolio-grid-layout">Portfolio Grid Layout</router-link></li>
                <li><router-link to="/portfolio-box-layout">Portfolio Box Layout</router-link></li>
            </ul>
        </li> -->
        <li><router-link to="/about">{{$t('about')}}</router-link></li>
        <li><router-link to="/contact">{{$t('contact')}}</router-link></li>
    </ul>
</template>

<script>
    import Icon from "../../icon/Icon";
    export default {
        name: 'Nav',
        components: {Icon},
        data() {
            return {
            }
        },
        computed: {
            isZh() {
                return this.$i18n.locale == 'zh';
            }
        },
        created() {
            // this.isZh = this.$i18n.locale == 'zh'
        },
    }
</script>